var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{ref:"customer",attrs:{"placeholder":"Selecione  uma opção"},on:{"change":function($event){return _vm.update()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.types),function(row){return _c('el-option',{key:row.id,attrs:{"label":row.name,"value":row.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }